function setup() {

	var ratio = window.devicePixelRatio;

	var w = $(".forp5").width() * ratio;
	var h = $(".forp5").height() * ratio;

	pixelDensity(1);

	let renderer = createCanvas(w, h);

	renderer.canvas.style.width = w / ratio + "px";
	renderer.canvas.style.height = h / ratio + "px";
	renderer.parent($(".forp5").get(0));
}

function draw() {
	clear();
	fill(170); // 填充颜色设置为黑色
	noStroke(); // 禁用邊框

	for (let y = -12; y <= height; y += 80) {
		hdot(y, y * 0.123)
	}

	for (let x = -12; x <= width; x += 80) {
		vdot(x, x * 0.123)
	}

}


function hdot(y, offy) {
	let offset = 0;

	for (let x = 0; x <= width; x += 10) {
		ellipse(x + sin(frameCount * 0.003 + offset) * cos(offy + frameCount * 0.01) * 300,
			y,
			sin(x * 0.001 + offy) * 2)
		offset += 0.16;
	}
}

function vdot(x, offx) {
	let offset = 0;

	for (let y = 0; y <= height; y += 10) {
		ellipse(x,
			y + sin(frameCount * 0.003 + offset) * cos(offx + frameCount * 0.01) * 300,
			sin(y * 0.001 + offx) * 2)
		offset += 0.08;
	}
}